import { jsPDF } from "jspdf";
import { drawQRCode } from "../drawqr";

/**
 * @param {any} props
 */
function empleados(props) {
  const param = props;
  const options = {
    format: "letter",
    orientation: "portrait",
    unit: "mm",
  };

  // let y = 20;
  // const qrSize = 40;
  // const marginX = 20;
  // const spacing = 60;
  // var currentHeight = 10;

  const pdfConfig = {
    headerTextSize: 20,
    labelTextSize: 10,
    blockWidth: 60, // Ancho del bloque por empleado
    blockHeight: 70, // Alto del bloque
    marginLeft: 15, // Margen lateral inicial
    marginTop: 25, // Margen superior
    spacingX: 0, // Espacio horizontal entre bloques
    spacingY: 0, // Espacio vertical entre filas
    qrSize: 35, // Tamaño del QR
    pageHeight: 279.4, // Altura útil de la página (letter - márgenes)
  };
  var doc = new jsPDF(options);

  doc.setFontSize(pdfConfig.headerTextSize);
  doc.setFont("helvetica", "bold");
  doc.text("Listado de Empleados con Código QR", 105, 10, null, null, "center");
  // currentHeight += pdfConfig.lineHeight;
  // let startX = pdfConfig.marginLeft;
  let startY = pdfConfig.marginTop;

  for (let i = 0; i < param.empleados.length; i++) {
    const empleado = param.empleados[i];
    const col = i % 3;
    //currentHeight += pdfConfig.lineHeight;

    // Si es la primera columna, reiniciar X
    const x =
      pdfConfig.marginLeft + col * (pdfConfig.blockWidth + pdfConfig.spacingX);

    // Verificar si el siguiente bloque excede la página
    const nextBlockBottom = startY + pdfConfig.blockHeight;
    if (nextBlockBottom > pdfConfig.pageHeight - 20) {
      // Añadir nueva página
      doc.addPage();
      doc.setFontSize(pdfConfig.headerTextSize);
      doc.text(
        "Listado de Empleados con Código QR",
        105,
        18,
        null,
        null,
        "center"
      );
      startY = pdfConfig.marginTop;
    }

    const y = startY;

    // 🟦 Dibujar recuadro del bloque
    doc.setDrawColor(100); // Gris suave
    doc.setLineWidth(0.3);
    doc.rect(x, y, pdfConfig.blockWidth, pdfConfig.blockHeight);

    // 📏 Calcular posición central del bloque
    const centerX = x + pdfConfig.blockWidth / 2;
    const centerY = y + pdfConfig.blockHeight / 2;

    // Recalcular posiciones si hubo salto

    // 🔲 QR centrado vertical y horizontal
    const qrX = centerX - pdfConfig.qrSize / 2;
    const qrY = centerY - pdfConfig.qrSize / 2 - 5; // QR un poco más arriba
    drawQRCode(
      `${empleado.codigo_empleado}`,
      { x: qrX, y: qrY, size: pdfConfig.qrSize },
      doc
    );

    // 🧠 Texto centrado debajo del QR
    doc.setFontSize(pdfConfig.labelTextSize);
    doc.text(empleado.nombre, centerX, qrY + pdfConfig.qrSize + 8, {
      align: "center",
    });
    doc.text(empleado.apellido, centerX, qrY + pdfConfig.qrSize + 14, {
      align: "center",
    });
    doc.text(empleado.codigo_empleado, centerX, qrY + pdfConfig.qrSize + 20, {
      align: "center",
    });

    // Mover a la siguiente fila después de 3 columnas
    if ((i + 1) % 3 === 0) {
      startY += pdfConfig.blockHeight + pdfConfig.spacingY;
    }
    //currentHeight += pdfConfig.lineHeight;
  }
  return doc;
}
export default empleados;
